import { Component, OnInit, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  constructor(
    private titleService: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Sign Up \u2013 Al Qaryah Cars Auction | Buyer & Seller Registration');
    
    this.meta.updateTag({
      name: 'description',
      content: 'Create your Al Qaryah Cars Auction account as a buyer or seller. Register to bid on vehicles, list cars for sale, and track live auctions online.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'al qaryah terms and condition, sharjah auto auction, al qaryah auction, terms and conditions, Used cars in auction, uae car auction, auction cars in dubai, auction cars dubai, cars auction dubai, auction process, auction registration, auction approval, cars in sharjah, sharjah used car market, cheap cars for sale in uae, used cars in sharjah, luxury car auctions near me, classic cars auction, collector car auctions, classic car auctions online, sharjah cars, sharjah auction laws, car approval timing, auction car approval, cars auction sharjah, auction, cars auction'
    });

    this.meta.updateTag({
      name: 'author',
      content: 'Al Qaryah Auction'
    });

    this.meta.updateTag({
      name: 'publisher',
      content: 'Al Qaryah Auction'
    });

    this.meta.updateTag({
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    });

    this.meta.updateTag({
      property: 'og:title',
      content: 'Sign Up \u2013 Al Qaryah Cars Auction | Buyer & Seller Registration'
    });

    this.meta.updateTag({
      property: 'og:description',
      content: 'Create your Al Qaryah Cars Auction account as a buyer or seller. Register to bid on vehicles, list cars for sale, and track live auctions online.'
    });

    this.meta.updateTag({
      property: 'og:type',
      content: 'website'
    });

    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });

    this.meta.updateTag({
      name: 'twitter:title',
      content: 'Sign Up \u2013 Al Qaryah Cars Auction | Buyer & Seller Registration'
    });

    this.meta.updateTag({
      name: 'twitter:description',
      content: 'Create your Al Qaryah Cars Auction account as a buyer or seller. Register to bid on vehicles, list cars for sale, and track live auctions online.'
    });

    this.setCanonicalURL('https://alqaryahauction.com/sign-up');
  }

  setCanonicalURL(url: string): void {
    let link: HTMLLinkElement = this.doc.querySelector("link[rel='canonical']") || null;
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.doc.head.appendChild(link);
    }
  }

}
